module.exports = __webpack_public_path__ + "static/media/teo.608542ab.png";